// Plan refusals (docs/plan-limits-plan.md §6). The API answers 403 with a
// top-level `code` and a plain-English `message`; every page already toasts
// `err.message`, so the api-client maps these two codes here and no page has to.

export type PlanErrorCode = 'PLAN_FEATURE_LOCKED' | 'PLAN_LIMIT_REACHED';

// Plan §6 wording, for a refusal that arrives without its message.
const FALLBACK_MESSAGES: Record<PlanErrorCode, string> = {
  PLAN_FEATURE_LOCKED: 'This is not in your plan. Upgrade your plan to use it.',
  PLAN_LIMIT_REACHED: 'You have reached your plan limit. Upgrade your plan to get more.',
};

export function isPlanErrorCode(code: unknown): code is PlanErrorCode {
  return code === 'PLAN_FEATURE_LOCKED' || code === 'PLAN_LIMIT_REACHED';
}

/** The message to show for a plan refusal, or null when the error body is not one. */
export function planErrorMessage(body: Record<string, unknown> | null | undefined): string | null {
  const code = body?.code;
  if (!isPlanErrorCode(code)) return null;
  const message = body?.message;
  return typeof message === 'string' && message.trim() ? message : FALLBACK_MESSAGES[code];
}
